import {ChangeDetectionStrategy, Component, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {CustomerContactRowModel} from '../model/customer-contact-row-model';
import {CustomerContactColumns} from '../model/customer-contact-columns';

@Component({
  selector: 'app-customer-contact-column',
  templateUrl: './customer-contact-column.component.html',
  styleUrls: ['./customer-contact-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerContactColumnComponent implements OnInit {


  @Input()
  row: CustomerContactRowModel;
  @Input()
  column: CustomerContactColumns.Column;

  @Input()
  showDeleteAction: boolean;
  @Output()
  private deleteClicked = new Subject<CustomerContactRowModel>();


  constructor() {
  }

  ngOnInit() {
  }

  getTitle(col: CustomerContactColumns.Column, row: CustomerContactRowModel) {
    const fields = col.field.split('.');
    const title = fields.reduce((cur, next) => {
      if (cur == null || cur[next] == null) {
        return null;
      }
      return cur[next];
    }, row);
    return title;
  }


  onDeleteClicked(row: CustomerContactRowModel, event: Event) {
    this.deleteClicked.next(row);
    event.preventDefault();
    event.stopImmediatePropagation();
  }


  discardEvent(event: Event) {
    event.stopImmediatePropagation();
  }
}
